import project2 from '../project2/project2';
import vs from './pbr-vertex.glsl';
import fs from './pbr-fragment.glsl';
export default {
  name: 'pbr',
  vs: vs,
  fs: fs,
  dependencies: [project2] // getUniforms

};
//# sourceMappingURL=pbr.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/shadertools/src/modules/pbr/pbr.js
// module id = 1583
// module chunks = 0